/*!
 * doTERRA Web-UI
 * http://www.doterra.com
 *
 * Copyright 2019 doTERRA Holdings, LLC
 * All Rights Reserved
 */
import React, { useContext, useEffect, useReducer } from 'react';

const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';

const AuthenticationStateContext = React.createContext();
const AuthenticationDispatchContext = React.createContext();

const AuthenticationReducer = (state, action) => {
    switch (action.type) {
        case SET_ACCESS_TOKEN: {
            if (state.accessToken !== action.payload) {
                return {...state, accessToken: action.payload};
            }
            return state;
        }
        default: {
            throw new Error(`[AuthenticationReducer] Unsupported action type: ${action.type}.`);
        }
    }
};

export const AuthenticationProvider = ({children}) => {
    const [state, dispatch] = useReducer(AuthenticationReducer, {accessToken: null}); // NOTE: as of now, the accessToken is the token required by the OCC implementation

    useEffect(() => {
        // TODO: retrieve the OCC accessToken
    });

    return (
        <AuthenticationStateContext.Provider value={state}> 
            <AuthenticationDispatchContext.Provider value={dispatch}>
                {children}
            </AuthenticationDispatchContext.Provider>
        </AuthenticationStateContext.Provider>
    );

};

export const useAuthenticationState = () => {
    const context = useContext(AuthenticationStateContext);
    if (!context) {
        throw new Error('useAuthenticationState must be used within an AuthenticationProvider');
    }
    return context;
};

export const useAuthenticationMutator = () => {
    const dispatch = useContext(AuthenticationDispatchContext);
    if (!dispatch) {
        throw new Error('useAuthenticationMutator must be used within a AuthenticationProvider');
    }
    const setAccessToken = (token) => {
        dispatch({type: SET_ACCESS_TOKEN, payload: token});
    };
    return {setAccessToken};
};
